export const queryGroupName = 'permit';
